/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import  Carousel  from 'mfcl/Carousel';
import * as React from 'react';
import _getViewPort from '../../Utilities/get-view-port';
import { ID5MfrmContentReelViewProps } from './d5-mfrm-content-reel';

export default (props: ID5MfrmContentReelViewProps) => {
    const [loaded, setIsLoaded] = React.useState(false);
    const hideLoader = () => {
        setIsLoaded(true);
    };
    const styles = 'd5-mfrm-content-reel__';
    const {
        config: { heading },
        carouselItems
    } = props;
    const mobile = _getViewPort(props.context) === 'sm';
    const hideSideArrowsForDesktopCss = carouselItems.length > 4 ? '' : 'min-desktop';

    let headingDisplay = null;
    if (heading && heading.text) {
        const HeadingTag = heading.tag ? (`${heading.tag}` as keyof JSX.IntrinsicElements) : 'h2';
        headingDisplay = (
            <div className='row'>
                <HeadingTag className={`${styles}heading`}>{heading.text}</HeadingTag>
            </div>
        );
    }

    React.useEffect(hideLoader, []);
    return (
        <div className='d5-mfrm-content-reel' data-cy='d5-sleep-experts-picks'>
            {headingDisplay}
            <div className={`mfcl-carousel__container ${loaded ? '' : 'carousel-loading'}`}>
                {mobile ? (
                    <div className='mfcl-carousel__mobile'>
                        <Carousel
                            itemsToShow={2}
                            ariaLabel='one'
                            hideIndicators
                            hideControls
                            disableControls
                            disableAutoShift
                            controlStyle='legacy'
                            controlClass={`mfcl-carousel__button`}
                            disableEndButtons={mobile}
                            variableWidth={mobile}
                        >
                            {carouselItems}
                        </Carousel>
                    </div>
                ) : (
                    <Carousel
                        itemsToShow={4}
                        ariaLabel='one'
                        hideIndicators
                        hideControls
                        infinite
                        controlStyle='legacy'
                        controlClass={`mfcl-carousel__button ${hideSideArrowsForDesktopCss}`}
                        disableEndButtons={mobile}
                        variableWidth={mobile}
                        responsive={[
                            {
                                breakpoint: 1150,
                                itemsToShow: 3
                            },
                            {
                                breakpoint: 768,
                                itemsToShow: 3,
                                layoutGap: 25
                            },
                            {
                                breakpoint: 593,
                                itemsToShow: 1,
                                layoutGap: 14
                            }
                        ]}
                    >
                        {carouselItems}
                    </Carousel>
                )}
            </div>
        </div>
    );
};
